import { Camera, PermissionStatus } from 'expo-camera'
import * as Location from 'expo-location'
import * as Notifications from 'expo-notifications'
import * as ImagePicker from 'expo-image-picker'


export class PermissionsAdapter {
    static async getRequestLocationPermission(): Promise<Location.PermissionStatus> {
        let { status } = await Location.getForegroundPermissionsAsync()
        return status
    }
    static async getRequestNotificationPermission(): Promise<Location.PermissionStatus> {
        let { status } = await Notifications.requestPermissionsAsync()
        return status
    }
    static async getRequestCameraPermission(): Promise<PermissionStatus> {
        // @ts-ignore - deprecated in expo-camera v15, but still works
        let { status } = await Camera.requestCameraPermissionsAsync()
        return status
    }
    static async getRequestImagePickerPermission(): Promise<Location.PermissionStatus> {
        let { status } = await ImagePicker.requestMediaLibraryPermissionsAsync()
        return status
    }

    // checks status of permissions
    static async checkLocationPermission(): Promise<Location.PermissionStatus> {
        let { status } = await Location.getForegroundPermissionsAsync()
        return status
    }
    static async checkNotificationPermission(): Promise<Location.PermissionStatus> {
        let { status } = await Notifications.getPermissionsAsync()
        return status
    }
    static async checkCameraPermission(): Promise<PermissionStatus> {
        // @ts-ignore - deprecated in expo-camera v15, but still works
        let { status } = await Camera.getCameraPermissionsAsync()
        return status
    }
    static async hasServicesEnabledAsync(): Promise<boolean> {
        return await Location.hasServicesEnabledAsync()
        // return status === 'granted'
    }
    static async checkMediaLibraryPermission(): Promise<Location.PermissionStatus> {
        let { status } = await ImagePicker.getMediaLibraryPermissionsAsync()
        return status
    }
}
